import React from 'react';
import styles from './styles.module.scss';

import Rating from '../Rating';
import noPhoto from '../../../assets/icons/review-no-photo.png';

const CommentBox = ({ rating }) => (
  <div className={styles.commentBox}>
    <h6>{rating?.Titulo}</h6>
    <div className={styles.commentRating}>
      <Rating value={rating?.Calificacion} />
    </div>
    <div className={styles.commentUser}>
      <img src={noPhoto} alt="user" />
      <p>{rating?.Nombre}</p>
    </div>
    <div className={styles.commentText}>
      <p>{rating?.Comentario}</p>
    </div>
  </div>
);

const Reviews = ({ refToReviews, content, login, spanish, productInfoApi }) => {
  const comments = productInfoApi.Comentarios?.map((comment, key) => (
    <CommentBox rating={comment} key={key} />
  ));
  return (
    <div className={styles.container} ref={refToReviews}>
      <div className={styles.header}>
        <h4>
          {spanish
            ? content?.ReviewsTitleSpanish
            : content?.ReviewsTitleEnglish}
        </h4>
        <div className={styles.rating}>
          <Rating value={productInfoApi?.Calificacion} />
        </div>
        <p>{`${productInfoApi?.Calificacion} ${
          spanish
            ? content?.ReviewAverageSpanish
            : content?.ReviewAverageEnglish
        }`}</p>
        <span>{`${0} ${spanish ? 'revisiones' : 'reviews'}`}</span>
        <a
          href={login?.LoginURL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-yellow"
        >
          {spanish
            ? content?.ShareCommentSpanish
            : content?.ShareCommentEnglish}
        </a>
      </div>
      <div className={styles.comments}>{comments}</div>
    </div>
  );
};

export default Reviews;
